import {TradingAlertDefinition} from "../../../models/alert/TradingAlert";
import {AlertDialogStore} from "./AlertDialogStore";
import {TradingAlertStatisticsService} from "../../../services/TradingAlertStatisticsService";

export const StoreFactory = "alertDialogStoreFactory";

export type AlertDialogStoreFactory = (initialData?: TradingAlertDefinition) => AlertDialogStore;

/** @ngInject */
export function alertDialogStoreFactory(tradingAlertStatisticsService: TradingAlertStatisticsService): AlertDialogStoreFactory {
    return (initialData) => new AlertDialogStore(tradingAlertStatisticsService, initialData);
}
